// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-header-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #000000;
    margin-bottom: 5px;
}

.card-header-sub-title {
    font-weight: 400;
    font-size: 12px;
    line-height: 20.2px;
    color: #5e5e5e;
    letter-spacing: 0.17px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Requerimento/Cadastro/TerceiraAba/ChecklistAnexoList.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,sBAAsB;AAC1B","sourcesContent":[".card-header-title {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.15px;\n    color: #000000;\n    margin-bottom: 5px;\n}\n\n.card-header-sub-title {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20.2px;\n    color: #5e5e5e;\n    letter-spacing: 0.17px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
